const LOCAL_STORAGE_KEY = 'fc_tour_progress';

const DEFAULT_PROGRESS_ENTRY = {
  started: false,
  completed: false,
  currentStep: 0
}

export class ProgressStore {
  constructor() {
    this._progress = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || '{}');
    this._save = this._save.bind(this);
  }

  _save() {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(this._progress));
  }

  get(tourID) {
    return this._progress[tourID] || { ...DEFAULT_PROGRESS_ENTRY };
  }

  setStarted(tourID) {
    this._progress[tourID] = {
      ...this.get(tourID),
      started: true
    };
    this._save();
  }

  setCompleted(tourID) {
    this._progress[tourID] = {
      ...this.get(tourID),
      completed: true
    };
    this._save();
  }

  setCurrentStep(tourID, currentStep) {
    this._progress[tourID] = {
      ...this.get(tourID),
      currentStep
    };
    this._save();
  }


}
